/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DimensionValuesRequestBody,
  DimensionValuesRequestBody$Outbound,
  DimensionValuesRequestBody$outboundSchema,
} from "../components/dimensionvaluesrequestbody.js";

export type AnalyticsDimensionValuesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AnalyticsDimensionValuesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  dimensionValuesRequestBody: DimensionValuesRequestBody;
};

/** @internal */
export type AnalyticsDimensionValuesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AnalyticsDimensionValuesSecurity$outboundSchema: z.ZodMiniType<
  AnalyticsDimensionValuesSecurity$Outbound,
  AnalyticsDimensionValuesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function analyticsDimensionValuesSecurityToJSON(
  analyticsDimensionValuesSecurity: AnalyticsDimensionValuesSecurity,
): string {
  return JSON.stringify(
    AnalyticsDimensionValuesSecurity$outboundSchema.parse(
      analyticsDimensionValuesSecurity,
    ),
  );
}

/** @internal */
export type AnalyticsDimensionValuesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DimensionValuesRequestBody: DimensionValuesRequestBody$Outbound;
};

/** @internal */
export const AnalyticsDimensionValuesRequest$outboundSchema: z.ZodMiniType<
  AnalyticsDimensionValuesRequest$Outbound,
  AnalyticsDimensionValuesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    dimensionValuesRequestBody: DimensionValuesRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      dimensionValuesRequestBody: "DimensionValuesRequestBody",
    });
  }),
);

export function analyticsDimensionValuesRequestToJSON(
  analyticsDimensionValuesRequest: AnalyticsDimensionValuesRequest,
): string {
  return JSON.stringify(
    AnalyticsDimensionValuesRequest$outboundSchema.parse(
      analyticsDimensionValuesRequest,
    ),
  );
}
